<div class="container-fuid bg-white default-boxrounded">
    <div class="row">
        <div class="col-12">
            <h3 class="title"><span translate="Settings.OrganisationStorageSection.EnableModal.DisableTitle"></span></h3>
        </div>
    </div>

    <div class="p-4 pt-0">
        <div class="col-12 pb-5">
            <span translate="Settings.OrganisationStorageSection.EnableModal.DisableInformation"></span>
        </div>

        <div class="col-12 mt-4 pb-2 d-table w-100">
            <span class="float-start"><button type="button" class="btn btn-sm btn-outline-primary" (click)="back()" translate="Button.Back"></button></span>
            <span class="float-end"><button type="submit" (click)="disableAzureBlobstorage()" id="buttonSave" class="btn btn-sm btn-danger" translate="Button.Disable"></button></span>
        </div>
    </div>
</div>